<template>
  <div>

    <router-link v-if="display" :to=info.link>
      <div v-if="display" class="blog-nav"> 
        <h1 v-if="pos==-1" class="cabin fw7 fs26 py-1 riTxt paral">Next</h1>
        <h1 v-if="pos==1"  class="cabin fw7 fs26 py-1 lfTxt paral">Previous</h1>
        
        <div class="nav-thumb" 
        :style="{
          backgroundImage:'url('+require('../../images/'+info.url+'.jpg')+')',
          backgroundPosition: info.urlPosition }">
        </div>

        <h2 v-if="pos==-1" class="deco mt-1 mb-5 fsSM16 fsMD20 fsLG22 fsXL22 paral riTxt fw7">{{info.title}}</h2>
        <h2 v-if="pos==1" class="deco mt-1 mb-5 fsSM16 fsMD20 fsLG22 fsXL22  paral lfTxt fw7">{{info.title}}</h2>
      </div>
    </router-link>

    <div v-if="!display"></div>

  </div>
</template>
<!--=================================================================================-->
<!--=====================================================================SCRIPTS=====-->
<!--=================================================================================-->
<script>
import blogs from './Blogs.json';

export default {
  name: "blog-nav",
  props: ['blogNum', 'pos'],
  data() {
    return {
      id: this.$route.params.id,
      post: 0,
      Blogs: blogs,
      display: false,
      info: "",
      action: ""
    };
  },
  methods: {
    getPost(){
      this.post=Number(this.id)+Number(this.pos);
      if(this.post>-1&&this.post<this.blogNum){
        this.info = this.Blogs[this.post];
        this.display = true;
      }
    }
  },
  watch: {
    '$route'(next){
      this.id = next.params.id;
    },
    id(){
      this.display = false;
      this.getPost();
    }
  },
  mounted() {
    this.getPost();
  }
}
</script>
<!--=================================================================================-->
<!--=====================================================================STYLING=====-->
<!--=================================================================================-->
<style scoped>
.blog-nav{
  color: #2F2E2E;
  border-radius: 4px;
  transition: all .3s ease-in-out;}
.blog-nav:hover{
  color: #4EA792;
  transform: scale(1.01);
}
.deco{
  line-height: 1em;
}
.nav-thumb{
  width: 100%;
  height: 17vh;
  background-position: center;
  background-size: cover;
}

</style>